import { c as _c } from "react/compiler-runtime";
import { IcoDotSmall16 } from '@onefootprint/icons';
import type { AuditEvent } from '@onefootprint/request-types/dashboard';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import useSecurityLogsQueryParams from '@/hooks/use-security-logs-filters';
import DateTime from './components/date-time';
import Event from './components/event';
import EventBody from './components/event-body';
import Loading from './loading';
const HEADER_HEIGHT = '32px';
export const getKeyForItemTime = (time: string) => {
  if (!time) {
    return 'empty';
  }
  const date = new Date(time);
  return format(date, 'yyyy-MM-dd-HH-mm-ss');
};
type TimelineProps = {
  auditEvents: AuditEvent[];
  isLoading: boolean;
  isError: boolean;
  showDecryptionReason: boolean;
};
const Timeline = t0 => {
  const $ = _c(18);
  const {
    auditEvents,
    isLoading,
    showDecryptionReason,
    isError
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.timeline"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  const queryParams = useSecurityLogsQueryParams();
  if (!queryParams.isReady || isLoading) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Loading />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (isError) {
    let t2;
    if ($[2] !== t) {
      t2 = t(_temp);
      $[2] = t;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t2) {
      t3 = <p className="text-body-2 text-primary fp-text">{t2}</p>;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  if (!auditEvents.length) {
    let t2;
    if ($[6] !== t) {
      t2 = t(_temp2);
      $[6] = t;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    let t3;
    if ($[8] !== t2) {
      t3 = <p className="text-body-2 text-primary fp-text">{t2}</p>;
      $[8] = t2;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  let t2;
  if ($[10] !== auditEvents || $[11] !== showDecryptionReason) {
    let t3;
    if ($[13] !== auditEvents.length || $[14] !== showDecryptionReason) {
      t3 = (accessEvent, i) => {
        const key = `${getKeyForItemTime(accessEvent.timestamp)}-${i}`;
        const last = i === auditEvents.length - 1;
        return <div key={key} className="grid relative h-auto items-start justify-start grid-cols-[24px_minmax(0,1fr)] [grid-template-areas:'icon_time'_'line_content'] md:grid-cols-[146px_24px_1fr] md:[grid-template-areas:'time_icon_content'_'empty_line_content']" style={{
          gridTemplateRows: `${HEADER_HEIGHT} auto`
        }}><div className="[grid-area:time] flex flex-row items-center gap-1" style={{
            height: HEADER_HEIGHT
          }}><DateTime timestamp={accessEvent.timestamp} /></div>{!last && <div className="[grid-area:line] absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-[1px] h-full bg-[var(--border-color-primary)]" />}<div className="[grid-area:icon] flex items-center justify-center bg-primary" style={{
            minHeight: HEADER_HEIGHT
          }}><IcoDotSmall16 /></div><div className="grid flex-col gap-2 ml-1 mt-1 pt-0.5 grid-cols-[minmax(0,1fr)] md:grid-cols-[1fr]" style={{
            gridArea: "content",
            gridTemplateAreas: "\"header\" \"body\"",
            gridTemplateRows: "auto auto"
          }}><div className="[grid-area:header] flex items-start justify-start"><Event auditEvent={accessEvent} /></div><span className="h-auto mt-2"><EventBody auditEvent={accessEvent} showDecryptionReason={showDecryptionReason} /></span></div></div>;
      };
      $[13] = auditEvents.length;
      $[14] = showDecryptionReason;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    t2 = auditEvents.map(t3);
    $[10] = auditEvents;
    $[11] = showDecryptionReason;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[16] !== t2) {
    t3 = <div className="flex flex-col">{t2}</div>;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};
export default Timeline;
function _temp($) {
  return $.error;
}
function _temp2($_0) {
  return $_0.empty;
}